import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';

import { DateFormat } from '../../../../utils/date';

import {
  SlotsSection,
  SlotsHeader,
  SlotsDate,
  SlotsListContainer,
  SlotItem,
  SlotTime,
  SlotSeats,
} from './styles';
import texts from './texts.json';

const SlotsList = ({
  selectedDate,
  selectedDateSlots,
  onSlotSelect,
  selectedSlot,
}) => {
  const handleSlotSelect = useCallback((slot) => {
    if (slot.seatsRemaining > 0) {
      onSlotSelect(slot);
    }
  }, [onSlotSelect]);

  return (
    <SlotsSection>
      <SlotsHeader>
        <SlotsDate>
          {selectedDate.format(DateFormat.DATE_FORMAT_WEEKDAY_MONTH_FORMAT)}
        </SlotsDate>
      </SlotsHeader>

      <SlotsListContainer>
        {selectedDateSlots.map((slot) => (
          slot.seatsRemaining > 0 && (
            <SlotItem
              key={slot.start}
              $disabled={slot.seatsRemaining === 0}
              onClick={() => handleSlotSelect(slot)}
              $selected={selectedSlot?.start === slot.start}
            >
              <SlotTime>{slot.displayTime}</SlotTime>
              <SlotSeats>
                {format(texts.seatsAvailable, { seats: slot.seatsRemaining })}
              </SlotSeats>
            </SlotItem>
          )
        ))}
      </SlotsListContainer>
    </SlotsSection>
  );
};

SlotsList.propTypes = {
  selectedDate: PropTypes.object.isRequired,
  selectedDateSlots: PropTypes.array.isRequired,
  onSlotSelect: PropTypes.func.isRequired,
  selectedSlot: PropTypes.object,
};

SlotsList.defaultProps = {
  selectedSlot: null,
};

export default SlotsList;
